<div>
  <form class="login"
        v-if="state == 'login'"
        @submit.prevent="login">
    <span v-if="error" class="error">{{error}}</span>
    <label for="username">Username or email:</label>
    <input id="username" ref="username">

    <label for="password">Password:</label>
    <input id="password"
           type="password"
           ref="password">
    <button type="submit">Login</button>
    <a href="#" @click="state = 'reset'">Reset password?</a>
  </form>

  <template v-if="state == 'reset'">
  <form class="login" @submit.prevent="reset">
    <h2> Reset Password </h2>
    <label for="email">Email:</label>
    <input id="email" ref="email">
    <button type="submit">Continue</button>
  </form>
  </template>
</div>
